module.exports = "/next-static/_next/static/images/obsView-c0560f16e89e1d8e567d8046af72ae83.png";